import {   Table, TableActionBarRow } from "melco-ui";
import { useTranslation } from "react-i18next";
import { useUsers } from "../../hooks/users/useUsers";
import { TransferLicenseUsersListFilter } from "./TransferLicenseUsersListFilter";
import { ConfirmExecuteTransferLicenseButton } from "./ConfirmExecuteTransferLicenseButton";


type UsersListPropTypes = {
   
    license: any;
    onClose?: () => void
}

export const TransferLicenseUsersList: React.FC<UsersListPropTypes> = ({
    license,
    onClose
}) => {

    const { t } = useTranslation();

    const { isLoading,
        isFetching,
        data,
        isPreviousData,
        errorComponent,
        onTableConfigChange,
        filtersChange,

    } = useUsers(false)

    const columns = [
        {
            title: t("users.table.column.id"),
            key: "id",
            width: 80,
            dataIndex: "id",
            sorter: true,


        },
       

        {
            title: t("users.table.column.account_name"),
            key: "account_name",
            width: 70,
            dataIndex: "account_name",
            sorter: true
        },
        {
            title: t("users.table.column.first_name"),
            key: "first_name",
            width: 70,
            dataIndex: "first_name",
            sorter: true,

        },
        {
            title: t("users.table.column.last_name"),
            key: "last_name",
            width: 70,
            dataIndex: "last_name",
            sorter: true,
        },

        {
            title: t("users.table.column.user_name"),
            key: "user_name",
            width: 70,
            dataIndex: "user_name",
            sorter: true,

        },
        {
            title: t("users.table.column.action"),
            key: "",
            width: 70,
           
            render: (row: any) => {
                return (<>
                    <ConfirmExecuteTransferLicenseButton
                        license={license}
                        newSelectedUser={row}
                        onCloseDrawer={onClose}
                    />
                </>
                )
            }


        },

    ];

   
    return (
        <>

                <TableActionBarRow>


                    <TransferLicenseUsersListFilter onFiltersChange={filtersChange} />
                </TableActionBarRow>


                <Table
                    showSorterTooltip={false}
                    scroll={{ y: `calc(100vh - 250px)` }}
                    loading={isPreviousData ? isFetching : isLoading}
                    dataSource={data}
                    columns={columns}
                    onChange={onTableConfigChange}
                    pagination={false}
                    rowKey="id"
                    //rowSelection={rowSelection}
                    // onRow={onRow}
                    noDataMessage={t("users.table.no_data_message")}
                    errorComponent={errorComponent}
                />
          
        </>
    );
};
